// extracted by mini-css-extract-plugin
module.exports = {"text-warning":"text-warning__Z7QE+","loading":"loading__sxOea","icon":"icon__XgGck","button-loader":"button-loader__0423S"};